const environment = (typeof window !== 'undefined' && window.PlatformSetup) || {
  production: true,
  loaderUrl: 'https://d2i76d1bskcqlp.cloudfront.net/site/upload/promotion/bizloadtrue.svg',
  sentryKey: 'https://913196a6014545bda28200a38ba9826a@sentry.softlabs.com/9',
  sentryEnvironment: "production",
  platformName: "bizzo",
};

module.exports = { environment };
